export default __webpack_public_path__ + "static/media/1_1_2.dab81eb2.png";